import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { WizardComponent } from './components/wizard/wizard.component';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CURRENCY_MASK_CONFIG, CurrencyMaskConfig, CurrencyMaskModule } from 'ng2-currency-mask';
import { MatDialogModule } from '@angular/material/dialog';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from "ng-recaptcha-2";
import { environment } from '../environments/environment';
import { MatTooltipModule } from '@angular/material/tooltip';
import { EmailDialogComponent } from './components/email-dialog/email-dialog.component';
import { ErrorDialogComponent } from './components/error-dialog/error-dialog.component';
import { SponsorDialogComponent } from './components/sponsor-dialog/sponsor-dialog.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { LeadApi } from './api/leadApi';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ErrorInterceptor } from './interceptors/error-interceptor';
import { Router } from '@angular/router';
import * as Sentry from "@sentry/angular";
import { LandingComponent } from './components/landing/landing.component';
import { UnsubscribeComponent } from './components/unsubscribe/unsubscribe.component';

export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
  align: "left",
  allowNegative: true,
  decimal: ".",
  precision: 2,
  prefix: "R",
  suffix: "",
  thousands: " "
};
@NgModule({
  declarations: [
    AppComponent,
    WizardComponent,
    HeaderComponent,
    FooterComponent,
    ErrorDialogComponent,
    EmailDialogComponent,
    SponsorDialogComponent,
    LandingComponent,
    UnsubscribeComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CurrencyMaskModule,
    MatDialogModule,
    RecaptchaV3Module,
    MatTooltipModule,
    MatAutocompleteModule,
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    LeadApi,
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: CURRENCY_MASK_CONFIG, useValue: CustomCurrencyMaskConfig },
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: environment.recaptcha.siteKey,
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
